import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id"],
  _excluded2 = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Grid from "@/components/Grid";
import { useChannelFeatureEpisodesQuery } from "@/hooks";
import { GRID_PAGE_LIMIT } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ChannelFeatureEpisodesGrid(_ref) {
  let {
      id
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const _useChannelFeatureEpi = useChannelFeatureEpisodesQuery({
      variables: {
        id: parseInt(id, 10),
        offset: 0,
        limit: GRID_PAGE_LIMIT
      },
      nextFetchPolicy: "cache-first"
    }),
    {
      data
    } = _useChannelFeatureEpi,
    result = _objectWithoutProperties(_useChannelFeatureEpi, _excluded2);
  const items = data === null || data === void 0 ? void 0 : data.channelFeatureEpisodes;
  return /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread(_objectSpread({}, props), {}, {
    items: items
  }, result), {}, {
    limit: GRID_PAGE_LIMIT,
    viewTypeClassName: "grid"
  }));
}